import $ from 'jquery';

require("selectize");
require("./latinise");

export default class AddProduct {

  constructor() {


    this.brandnames = [];
    this.companynames = [];

    $(".selectize").selectize({
      plugins: ['remove_button']

    });

    $(".search_add").attr("disabled", "disabled");
    this.loadData(() => {
      $(".search_add").attr("disabled", false);
      $('.search_add').each((i, selector) => {
        $(selector).removeClass("form-control");
        let key = $(selector).data("key");
        let items = this[key];
        let options = {
          valueField: 'display',
          labelField: 'display',
          create: true,
          openOnFocus: false,
          maxItems: 1,
          render: {
            option: (item, escape) => {
              return '<div>' + escape(item.display) + "</div>";
            }
          },
          score: (query) => {
            let q = query.toLowerCase().latinise().replace(/\W/g, '');
            return (element) => {
              return element.key.indexOf(q) !== -1 ? 1: 0;
            };
          },
          load: (query, callback) => {
            if (!query.length) return callback();

            let res = this.search(items, query.toLowerCase().latinise().replace(/\W/g, ''));
            //console.log(res);

            callback(res);

          }
        };

        $(selector).selectize(options);
      });



    });


  }

  search(list, query) {
    console.log(query);
    return $.grep(list, element => {
      let t = element.key.indexOf(query) !== -1;
      return t;
    });
  }


  loadData(callback) {

    $.ajax({data:{op:"preloadSearchData"},
      success: (d, s) => {

        if (d.brandnames) {
          this.brandnames = this.preprocess(d.brandnames);
        }
        if (d.companynames) {
          this.companynames = this.preprocess(d.companynames);
        }

        callback();

      }

    })

  }

  preprocess(entries) {
    return $(entries).map((index, element) => {
      return {
        key: element.toLowerCase().latinise().replace(/\W/g, ''),
        display: element
      };
    });

  }


}
